// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"87541794","453":"3f05b7d2"}[chunkId] + ".chunk.js";
};